import React, { Fragment } from 'react'
import Picture from '../../components/Picture'
import SingleTestimonialCard from './SingleTestimonialCard'
import './TwoColsV2.scss'

const TwoColsV2 = ({
  overTitle,
  title,
  description,
  imageSrc,
  imageAlt,
  mobileSrc,
  isReverse = false,
  isImageFullWidth = false,
  testimonial,
  className = '',
  children,
  radialBg,
  testimonialElementType = 'h4',
  descriptionElementType = 'div',
  separateHeadings = false
}) => {
  const sectionClass = `two-cols-v2 ${isReverse ? 'reverse' : ''} ${isImageFullWidth ? 'full-width-image' : ''} ${className}`
  const DescriptionElement = descriptionElementType

  return (
    <section className={sectionClass}>
      {radialBg && <div className={`radial-bg ${radialBg} small`}></div>}
      <div className="container">
        <div className="content-column">
          {separateHeadings ? (
            <Fragment>
              {overTitle && <p className="over-title">{overTitle}</p>}
              {title && <h3 className="title">{title}</h3>}
            </Fragment>
          ) : (
            <h3>{overTitle && <div className="over-title">{overTitle}</div>}
            {title && <div className="title">{title}</div>}</h3>
          )}
          {description && <DescriptionElement className="description">{description}</DescriptionElement>}
          {/* Mobile image - shown only on mobile */}
          <div className="mobile-only">
            <Picture
              className="section-image"
              src={imageSrc}
              alt={imageAlt}
              mobileSrc={mobileSrc}
            />
          </div>
          {children}
          {testimonial && <SingleTestimonialCard {...testimonial} testimonialElementType={testimonialElementType} />}
        </div>
        <div className="image-column desktop-only">
          <Picture
            className="section-image"
            src={imageSrc}
            alt={imageAlt}
            mobileSrc={mobileSrc}
          />
        </div>
      </div>
    </section>
  )
}

export default TwoColsV2


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/TwoColsV2.jsx